<template>
  <div class="main pages-registration-learning-paths-list">
    <Sidebar :current-keywords="keywords" @search="setKeywords">
      <div
        slot="header"
        class="title-bar row no-gutters px-0 py-3 d-xl-none px-lg-3"
      >
        <div class="col-12 text-center mb-3 col-lg-4 text-lg-left mb-lg-0">
          <h1>Learning Paths</h1>
        </div>
        <div class="col-12 col-lg-8">
          <Toggles :toggles="toggles" />
        </div>
      </div>
      <div slot="custom-filters" class="custom-filters">
        <div class="inner">
          <Field
            v-for="(tag, i) in tags"
            :key="i"
            type="checkbox"
            :id="`tag_${tag.value}`"
            name="tags[]"
            :label="tag.label"
            v-model="selectedTags"
            :checkboxValue="tag.value"
            element-class="custom-control custom-checkbox mb-1"
            input-class="custom-control-input"
            label-class="custom-control-label font-weight-normal"
          />
        </div>
      </div>
    </Sidebar>

    <div class="title-bar row no-gutters p-3 d-none d-xl-flex">
      <div class="col-6">
        <h1>Learning Paths</h1>
      </div>
      <div class="col-6">
        <Toggles :toggles="toggles" />
      </div>
    </div>

    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <div
            v-if="!!items && items.length > 0"
            class="learning-path-list row no-gutters"
          >
            <div
              v-for="(item, i) in items"
              :key="i"
              class="col-12 col-md-4 pb-3 px-md-2"
            >
              <ListCard :learning-path="item" />
            </div>
          </div>
          <div v-else-if="!hideNoResults" class="alert alert-info text-center">
            <p class="m-0">No results found. Try broadening your search.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center mb-3 col-lg-6 text-lg-left mb-lg-0">
          <Pagination
            class="d-inline-block"
            :total="totalPages"
            :value="parseInt(pagination.current)"
            @input="setCurrentPage"
          />
        </div>
        <div class="col-12 text-center col-lg-6 text-lg-right">
          <PageSize
            :value="parseInt(pagination.per_page)"
            :sizes="pageSizes"
            @input="setPerPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListingMixin from "mixins/Listing";
import ListCard from "components/partials/LearningPaths/ListCard";
export default {
  mixins: [ListingMixin],
  components: { ListCard },
  props: {
    tags: { type: Array, default: () => [] },
    toggles: { type: Array, default: () => [] },
  },
  data() {
    return {
      pageSizes: [
        { value: 9, label: "9" },
        { value: 18, label: "18" },
        { value: 27, label: "27" },
        { value: 36, label: "36" },
        { value: 45, label: "45" },
      ],
      selectedTags: [],
    };
  },
  watch: {
    selectedTags(val) {
      this.replaceFilter("tag", val);
    },
  },
  mounted() {
    if (_.has(this.filters, "tag")) {
      this.selectedTags = _.cloneDeep(this.filters.tag);
    }
  },
};
</script>